var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"baseForm",attrs:{"options":_vm.options,"disabled":this.contractStatusList.indexOf(_vm.data.contractStatus) != -1 ? false : _vm.disabled,"rules":_vm.rules,"labelWidth":"95px"},on:{"input":_vm.handleChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }